<template>
    <div class="z-filter-content row">
        <component
            v-for="(item, key, index) in structure"
            :key="index"
            :is="item.type"
            v-model="model[key]"
            :="item.props"
            :class="item.class"
            :disabled="item.disabled"
            is-filter
        ></component>
    </div>
    <div class="z-filter-content__button-wrapper">
        <z-button
            v-if="isFilterActive"
            @click="clear"
            :size="resetButtonSize"
            kind="bordered"
            class="z-filter-content__button"
        >
            <span v-html="text.reset"></span>
        </z-button>
    </div>
</template>

<script setup>
import { localize } from '@/utils/i18n'
import { computed, watch, onBeforeMount } from 'vue'

import {
    queryString,
    clearEmptyParams,
    getGetParams
} from '@/utils/filterUtils'

const props = defineProps({
    structure: {
        type: Object
    },
    resetButtonSize: {
        type: String,
        default: 's'
    }
})
const emit = defineEmits([
    'update-params'
])

const model = defineModel();
const defaultModel = structuredClone(model.value);

const text = {
    date: localize({
        ru: 'Дата',
        en: 'Date',
        cn: 'Date'
    }),
    q: localize({
        ru: 'Поиск по названию',
        en: 'Search',
        cn: '搜索'
    }),
    reset: localize({
        ru: 'Сбросить фильтр',
        en: 'Reset filter',
        cn: '重置筛选条件'
    })
}
let params = { ...model.value }
const isFilterActive = computed(() => {
    return JSON.stringify(model.value) !== JSON.stringify(defaultModel);
})

const emitUpdateParams = () => {
    params = { ...model.value }

    if (params.date !== undefined && params.date !== null) {
        if(params.date){
            params.from = params.date[0];
            params.to = params.date[1];
            delete params.date;
        } else {
            // костыль
            params.from = '';
            params.to = '';
        }
    }

    emit('update-params',params)
}

const onFilterChange = () => {
    emitUpdateParams()
    queryString(clearEmptyParams(params));
}

const clear = () => {
    Object.assign(model.value, defaultModel);
    onFilterChange()
}

const getParams = () => {
    Object.assign(model.value, getGetParams());
    onFilterChange()
}

onBeforeMount (() => {
    getParams()
})

watch(model.value, onFilterChange);
</script>

<style lang="scss">
.z-filter-content {
    $parent: &;

    &__button-wrapper {
        display: flex;
        flex-direction: row-reverse;
    }

    .z-icon {
        path {
            fill: var( --color-link-default);
        }
    }
    .mx-icon-calendar {
        background-image: svg-load('calendar/calendar.svg', fill=#22604F);
    }
}
</style>
